export var EField;
(function (EField) {
    EField["Header1"] = "_header1";
    EField["Header2"] = "_header2";
    EField["Header3"] = "_header3";
    EField["InfoBox1"] = "_infoBox1";
    EField["Name"] = "name";
    EField["NameNew"] = "nameNew";
    EField["Group"] = "group";
    EField["GroupNew"] = "groupNew";
    EField["Required"] = "required";
    EField["EditableByTenant"] = "editableByTenant";
    EField["Type"] = "type";
    EField["DefaultText"] = "defaultText";
    EField["IsMultilineText"] = "isMultilineText";
    EField["DefaultDate"] = "defaultDate";
    EField["DefaultDateFormatting"] = "defaultDateFormatting";
    EField["MinDate"] = "minDate";
    EField["MaxDate"] = "maxDate";
    EField["DefaultNumber"] = "defaultNumber";
    EField["MinNumber"] = "minNumber";
    EField["MaxNumber"] = "maxNumber";
    EField["DefaultToggle"] = "defaultToggle";
    EField["DropdownValues"] = "dropdownValues";
    EField["Persisted"] = "persisted";
})(EField || (EField = {}));
